import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Print from '@material-ui/icons/Print';
import QRCode from 'qrcode.react';
import TextField from '@material-ui/core/TextField';
import ContentAdd from '@material-ui/icons/Add';
import {
  Divider,
  injectIntl,
  PrintPreviewDialog,
  NotificationBadge,
  Tooltip,
} from 'components';
import SelectField from 'components/SmartForm/components/SelectField';
import { FRInput } from 'elements';
import {
  formatPhoneNumber,
  toLongDateFormat,
  updatedClassname,
  // getFullNameOrEmail,
} from 'helpers/utils';
import { isMobile } from 'helpers/detect-mobile';
import { getAddressIndex, getAddressOptions } from 'helpers/address';
import AddItemToOrderModal from '../../../components/AddItemToOrderModal';


import Activities from './Activities';
import InvoicePrint from './InvoicePrint';
import BottomPanel from './BottomPanel';

const styles = theme => ({
  selectFloatingLabel: { width: '120%' },
  selectLabel: {
    color: 'grey',
  },
  selectRoot: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '50%',
    },
    maxWidth: '200px',
  },
  btnActivities: {
    color: '#333333',
    fontWeight: '600',
  },
  badge: {
    marginLeft: 15,
  },
  badgeSpan: {
    backgroundColor: '#ff602e',
    color: 'white',
  },
  enableChangeButton: {
    padding: 0,
  },
  addBtnLabel: { color: '#fff' },
  btnLabel: {
    display:'flex',
    alignItems: 'center',
    marginLeft:'10px',
    marginRight: '10px',
    fontWeight: 500,
  }
});

class TopPanel extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    readOnly: PropTypes.bool,
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    info: PropTypes.shape({}).isRequired,
    currentActivity: PropTypes.shape({}),
    editDisabled: PropTypes.bool,

    changeFromAddress: PropTypes.func.isRequired,
    changeToAddress: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    updateOrder: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
    onClickActivity: PropTypes.func,
    orderRequesting: PropTypes.bool,
    refundedAmount: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    totalDue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    validateTax: PropTypes.func,
    changeTax: PropTypes.func,
    validateReduction: PropTypes.func,
    changeReduction: PropTypes.func,
    validateCredit: PropTypes.func,
    changeCredit: PropTypes.func,
    validateDeliveryFee: PropTypes.func,
    changeDeliveryFee: PropTypes.func,
    changeDiscountValue: PropTypes.func,
    buyerConfirmOrder: PropTypes.func,
    placeOrder: PropTypes.func,
    sellerConfirmOrder: PropTypes.func,
    buyerMembers: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
  };

  static defaultProps = {
    data: [],
    editDisabled: false,
    currentActivity: {},
    onClickActivity: noop,
    orderRequesting: false,
    refundedAmount: null,
    totalDue: null,
    changeTax: noop,
    changeDeliveryFee: noop,
    changeDiscountValue: noop,
    buyerConfirmOrder: noop,
    placeOrder: noop,
    sellerConfirmOrder: noop,
    buyerMembers: [],
  };

  state = {
    openModel: false,
    showActivities: true,
    printDlgOpen: false,
    showToAddressField: false,
    internalNote: (this.props.info.type === 'PO' ? this.props.info.buyerNote || '' : this.props.info.sellerNote || ''),
    noteToSeller: this.props.info.noteToSeller,
  };

  componentWillReceiveProps({ info }) {
    if (this.props.info.noteToSeller !== info.noteToSeller) {
      this.setState({ noteToSeller: info.noteToSeller });
    }
    if(this.props.info.type === 'PO') {
      if (this.props.info.buyerNote !== info.buyerNote && this.state.internalNote !== info.buyerNote) {
        this.setState({ internalNote: info.buyerNote });
      }
    }else{
      if (this.props.info.sellerNote !== info.sellerNote && this.state.sellerNote !== info.sellerNote) {
        this.setState({ internalNote: info.sellerNote });
      }
    }
    
  }

  onPrintClose = () => this.setState({ printDlgOpen: false });
  onPrintOpen = () => this.setState({ printDlgOpen: true });
  onShowAddressField = () => {
    const { showToAddressField } = this.state;
    this.setState({ showToAddressField: !showToAddressField });
  };

  handleOpenModal = () => this.setState({ openModel: true });
  handleCloseModal = () => this.setState({ openModel: false });

  handleAddItemToOrder = () => {};

  updateNote = (note) => {
    const { info, updateOrder } = this.props;
    const noteKey = info.type === 'PO' ? 'buyerNote' : 'sellerNote';
    const emptyCase = note === '' && info[noteKey] === null;
    if (note !== info[noteKey] && !emptyCase) {
      updateOrder(info.id, { [noteKey]: note });
    }
  };

  updateNoteToSeller = (note) => {
    const { info, updateOrder } = this.props;
    const emptyCase = note === '' && info.noteToSeller === null;
    if (note !== info.noteToSeller && !emptyCase) {
      updateOrder(info.id, { noteToSeller: note });
    }
  };

  render() {
    const {
      classes,
      currentUser,
      data,
      fields,
      info,
      editDisabled,
      changeFromAddress,
      changeToAddress,
      currentActivity,
      formatMessage,
      onClickActivity,
      orderRequesting,
      refundedAmount,
      totalDue,
      validateTax,
      changeTax,
      validateReduction,
      changeReduction,
      validateCredit,
      changeCredit,
      validateDeliveryFee,
      changeDeliveryFee,
      changeDiscountValue,
      buyerConfirmOrder,
      placeOrder,
      sellerConfirmOrder,
      buyerMembers,
      readOrder,
    } = this.props;
    const { showActivities, printDlgOpen, showToAddressField, internalNote, noteToSeller } = this.state;
    const { isRestaurant, readOnly, isDistributor, isFarmer, isConsumer } = this.context;

    const isContactInfo = !!info.contact;
    const contactDeleted =
      get(info, 'contact.isDeleted') ||
      get(info, 'contact.sellerProfile.isOff');

    const fromAddresses =
      get(info, 'contact.sellerProfile.addresses') ||
      get(info, 'seller.account.profile.addresses');
    const fromAddressList = getAddressOptions(fromAddresses);
    const fromAddress = info.sellerAddress;
    const fromAddressIndex = getAddressIndex(fromAddresses, fromAddress);

    const toAddresses =
      get(info, 'contact.buyerProfile.addresses') ||
      get(info, 'buyer.account.profile.addresses');
    const toAddressList = getAddressOptions(toAddresses);
    const toAddress = info.buyerAddress;
    const toAddressIndex = getAddressIndex(toAddresses, toAddress);
    const editorProfile = get(info, 'editorMember.profile') || {};
    const creatorProfile = get(info, 'creatorAccount.profile') || {};
    const creatorBusinessName = creatorProfile.companyName ? creatorProfile.companyName : `${creatorProfile.firstName} ${creatorProfile.lastName}`;
    const buyerProfile = get(info, 'buyer.account.profile') || {};
    const buyerBusinessName = buyerProfile.companyName ? buyerProfile.companyName : `${buyerProfile.firstName} ${buyerProfile.lastName}`;
    // const fullNameOrEmail = getFullNameOrEmail(currentUser.organizations[0].account);
    const showAll = false;
    const filteredData = data.filter(item => item.quantity > 0);
    const customerRoleId = get(info, 'buyer.roleId');
    const customerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[customerRoleId] || 'Personal';
    const isAggregatedOrder = JSON.parse(info.createdAsDraft || false);

    return (
      <div>
        <div className="top-panel">
          <div className="top-first-pane d-lg-down-none">
            <div className="qr-code-section">
              <div className="tracking-number">
                {formatMessage('Transaction ID')}:
                <span className="tracking-id">{info.id}</span>
              </div>
              <div className="invoice-number">Invoice #{info.orderNum}</div>
            </div>
            <QRCode size={64} value={`order - ${info.id}`} />
            <div className="top-second-pane">
              <div style={{ fontSize: 20, fontWeight: 100, paddingRight: 20 }}>
                <span style={{ marginRight: 10, fontWeight: 400 }}>
                  {formatMessage('Order date')}:
                </span>
                {toLongDateFormat(info.deliveryDate)}
              </div>
              {
                <div>
                  <Tooltip tooltip={formatMessage('Print')}>
                    <IconButton
                      onClick={this.onPrintOpen}
                      style={{ padding: 5 }}
                    >
                      <Print />
                    </IconButton>
                  </Tooltip>
                  <PrintPreviewDialog
                    onClose={this.onPrintClose}
                    open={printDlgOpen}
                    title={`${formatMessage('Print Preview')} - ${formatMessage(
                      'Order',
                    )} #${info.id}`}
                  >
                    <InvoicePrint
                      currentUser={currentUser}
                      data={filteredData}
                      fields={fields}
                      formatMessage={formatMessage}
                      info={info}
                      userLogoImage={currentUser.userLogoImage}
                    />
                  </PrintPreviewDialog>
                </div>
              }
            </div>
            { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isFarmer) ? (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
              </div>
            ) : !info.creatorAccountId && isFarmer && !info.isDraft && buyerMembers.length > 0 && (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
              </div>
            )}
            { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isDistributor && (info.type !== 'PO' || (info.type === 'PO' && isAggregatedOrder !== true))) ? (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
              </div>
            ) : !info.creatorAccountId && isDistributor && info.type !== 'PO' && buyerMembers.length > 0 && (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
              </div>
            )}
            { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isRestaurant) ? (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
              </div>
            ) : !info.creatorAccountId && isRestaurant && buyerMembers.length > 0 && (
              <div>
                <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
              </div>
            )}
          </div>
          <div className="top-first-pane d-lg-up-none">
            <div>
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 100,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                }}
              >
                <div>
                  <div style={{ fontWeight: 400, marginRight: 10 }}>
                    {formatMessage('Order date')}:
                  </div>
                  <div style={{ fontSize: 28 }}>
                    {toLongDateFormat(info.deliveryDate)}
                  </div>
                </div>
                {
                  <div>
                    <Tooltip tooltip={formatMessage('Print')}>
                      <IconButton
                        onClick={this.onPrintOpen}
                        style={{ padding: 5, marginLeft: 10, marginRight: 10 }}
                      >
                        <Print />
                      </IconButton>
                    </Tooltip>
                    <PrintPreviewDialog
                      onClose={this.onPrintClose}
                      open={printDlgOpen}
                      title={`${formatMessage(
                        'Print Preview',
                      )} - ${formatMessage('Order')} #${info.id}`}
                    >
                      <InvoicePrint
                        currentUser={currentUser}
                        data={filteredData}
                        fields={fields}
                        formatMessage={formatMessage}
                        info={info}
                        userLogoImage={currentUser.userLogoImage}
                      />
                    </PrintPreviewDialog>
                  </div>
                }
              </div>

              <div className="tracking-number">
                {formatMessage('Transaction ID')}:{' '}
                <span className="tracking-id">{info.id}</span>
              </div>
              <div className="invoice-number">Invoice #{info.orderNum}</div>
            </div>
            <div>
              <QRCode value={`order - ${info.id}`} size={isMobile ? 54 : 64} />
            </div>
            <div>
              {!!info.editorMemberId && (
                <div>
                  {formatMessage('Editor')}:{' '}
                  {`${editorProfile.firstName} ${editorProfile.lastName}`}
                </div>
              )}
            </div>
          </div>
          <Divider />
          <div className="from-to-blocks">
            <div className="from-to-block" style={{maxWidth: '350px'}}>
              <div className="right-gap grey">
                <b>{formatMessage('From')}:</b>
              </div>
              <div className="d-md-none d-xs-block">
                <b>
                  {get(info, 'contact.sellerProfile.companyName') ||
                    get(info, 'seller.account.profile.companyName')}
                </b>
              </div>
              {info.type === 'SO' && (
                <div className="d-md-none d-xs-block">
                  <SelectField
                    classes={{
                      root: { root: classes.selectRoot },
                      label: { root: classes.selectFloatingLabel },
                      select: { select: classes.selectLabel },
                    }}
                    defaultValue={fromAddressIndex}
                    disabled={
                      readOnly ||
                      editDisabled ||
                      contactDeleted ||
                      isRestaurant ||
                      !fromAddresses
                    }
                    fullWidth
                    name="fromAddress"
                    onChange={index => changeFromAddress(fromAddresses[index])}
                    options={fromAddressList}
                  />
                </div>
              )}
              <div
                className={updatedClassname(
                  this,
                  'fromAddress',
                  JSON.stringify(fromAddress),
                )}
              >
                <div className="d-md-block d-none">
                  <b>
                    {get(info, 'contact.sellerProfile.companyName') ||
                      get(info, 'seller.account.profile.companyName')}
                  </b>
                </div>
                <div className="d-none d-md-block">
                  {isContactInfo
                    ? `${get(info, 'contact.sellerProfile.firstName') ||
                        ''} ${get(info, 'contact.sellerProfile.lastName') ||
                        ''}`
                    : `${get(info, 'seller.account.profile.firstName')} ${get(
                        info,
                        'seller.account.profile.lastName',
                      )}`}
                </div>
                {info.type === 'SO' && (
                  <div className="d-none d-md-block">
                    <SelectField
                      classes={{
                        root: { root: classes.selectRoot },
                        label: { root: classes.selectFloatingLabel },
                        select: { select: classes.selectLabel },
                      }}
                      defaultValue={fromAddressIndex}
                      disabled={
                        readOnly ||
                        editDisabled ||
                        contactDeleted ||
                        isRestaurant ||
                        !fromAddresses
                      }
                      fullWidth
                      name="fromAddress"
                      onChange={index =>
                        changeFromAddress(fromAddresses[index])
                      }
                      options={fromAddressList}
                    />
                  </div>
                )}
                <div className="d-md-none d-xs-block">
                  {info && info.deliveryType === 2 && (
                    <span style={{ color: 'red' }}>{formatMessage('Pick-Up')}: </span>
                  )}
                  {[
                    fromAddress.address,
                    fromAddress.city,
                    fromAddress.state && fromAddress.zipcode
                      ? `${fromAddress.state || ''} - ${fromAddress.zipcode ||
                          ''}`
                      : '',
                  ].join(', ')}
                </div>
                <div className="d-none d-md-block">
                  <div>
                    {info && info.deliveryType === 2 && (
                      <span style={{ color: 'red' }}>{formatMessage('Pick-Up')}: </span>
                    )}
                    {fromAddress.address}
                  </div>
                  <div>{fromAddress.city}</div>
                  <div>
                    {fromAddress.state && fromAddress.zipcode
                      ? `${fromAddress.state || ''} - ${fromAddress.zipcode ||
                          ''}`
                      : ''}
                  </div>
                </div>
                <div className="email">
                  <span className="d-lg-down-none">
                    {formatMessage('Email')}:{' '}
                  </span>
                  {info.seller.account.email}
                </div>
                <div className="bottom-gap">
                  {formatMessage('Phone')}:{' '}
                  {formatPhoneNumber(
                    get(info, 'contact.sellerProfile.mobile') ||
                      get(info, 'seller.account.profile.mobile'),
                  )}
                </div>
                {get(info, 'seller.account.profile.organicNumber') && (
                  <div className="organic-handler">
                    {formatMessage('Organic Number')}:{' '}
                    {get(info, 'seller.account.profile.organicNumber')}
                  </div>
                )}
              </div>
            </div>
            <div className="from-to-block" style={{maxWidth: '350px'}}>
              <div className="right-gap grey">
                <b>{formatMessage('To')}:</b>
              </div>
              <div className="d-md-none d-xs-block">
                <b>
                  {get(info, 'contact.buyerProfile.companyName') ||
                    get(info, 'buyer.account.profile.companyName')}
                </b>
              </div>
              {(info.type === 'SO' ||
                (isDistributor && info.type === 'PO')) && (
                <div className="d-md-none d-xs-block">
                  <SelectField
                    classes={{
                      root: { root: classes.selectRoot },
                      label: { root: classes.selectFloatingLabel },
                      select: { select: classes.selectLabel },
                    }}
                    defaultValue={toAddressIndex}
                    disabled={
                      readOnly ||
                      editDisabled ||
                      contactDeleted ||
                      !toAddresses ||
                      info.type !== 'PO'
                    }
                    fullWidth
                    name="toAddress"
                    onChange={(index) => {
                      changeToAddress(toAddresses[index]);
                      this.onShowAddressField();
                    }}
                    options={toAddressList}
                  />
                </div>
              )}
              <div
                className={updatedClassname(
                  this,
                  'toAddress',
                  JSON.stringify(toAddress),
                )}
              >
                <div className="d-none d-md-block">
                  <b>
                    {get(info, 'contact.buyerProfile.companyName') ||
                      get(info, 'buyer.account.profile.companyName')}
                  </b>
                </div>
                <div>
                  { !isConsumer ? (isContactInfo 
                    ? `${get(info, 'contact.buyerProfile.firstName')} ${get(
                        info,
                        'contact.buyerProfile.lastName',
                      )}`
                    : `${get(info, 'buyer.account.profile.firstName')} ${get(
                        info,
                        'buyer.account.profile.lastName',
                      )}`
                    ) : null
                  }
                </div>
                {(info.type === 'SO' ||
                  (isDistributor && info.type === 'PO')) &&
                  (showToAddressField ? (
                    <div className="d-none d-md-block">
                      <SelectField
                        classes={{
                          root: { root: classes.selectRoot },
                          label: { root: classes.selectFloatingLabel },
                          select: { select: classes.selectLabel },
                        }}
                        defaultValue={toAddressIndex}
                        disabled={
                          readOnly ||
                          editDisabled ||
                          contactDeleted ||
                          !toAddresses
                        }
                        fullWidth
                        name="toAddress"
                        onChange={index => changeToAddress(toAddresses[index])}
                        options={toAddressList}
                      />
                    </div>
                  ) : (
                    <div className="d-none d-md-block">
                      <Button
                        onClick={this.onShowAddressField}
                        color="primary"
                        className={classes.enableChangeButton}
                      >
                        Change Address
                      </Button>
                    </div>
                  ))}
                <div className="d-md-none d-xs-block">
                  {[
                    toAddress.address,
                    toAddress.city,
                    toAddress.state && toAddress.zipcode
                      ? `${toAddress.state || ''} - ${toAddress.zipcode || ''}`
                      : '',
                  ].join(', ')}
                </div>
                <div className="d-none d-md-block">
                  <div>{toAddress.address}</div>
                  <div>{toAddress.city}</div>
                  <div>
                    {toAddress.state && toAddress.zipcode
                      ? `${toAddress.state || ''} - ${toAddress.zipcode || ''}`
                      : ''}
                  </div>
                </div>
                <div className="email">
                  <span className="d-none d-md-block">
                    {formatMessage('Email')}:{' '}
                  </span>
                  {info.buyer.account.email}
                </div>
                <div>
                  {formatMessage('Phone')}:{' '}
                  {formatPhoneNumber(
                    get(info, 'contact.buyerProfile.mobile') ||
                      get(info, 'buyer.account.profile.mobile'),
                  )}
                </div>
              </div>
            </div>
          </div>
          <BottomPanel
            validateTax={validateTax}
            changeTax={changeTax}
            validateReduction={validateReduction}
            changeReduction={changeReduction}
            validateCredit={validateCredit}
            changeCredit={changeCredit}
            validateDeliveryFee={validateDeliveryFee}
            changeDeliveryFee={changeDeliveryFee}
            changeDiscountValue={changeDiscountValue}
            editDisabled={editDisabled}
            fields={fields}
            formatMessage={formatMessage}
            info={info}
            isRestaurant={isRestaurant}
            onBuyerConfirmOrder={buyerConfirmOrder}
            onPlaceOrder={placeOrder}
            onSellerConfirmOrder={sellerConfirmOrder}
            orderRequesting={orderRequesting}
            placeOrder={info.type === 'PO' && info.isDraft}
            refundedAmount={refundedAmount}
            totalDue={totalDue}
            currentActivity={currentActivity}
          />
        </div>
        {(isConsumer || isFarmer) && <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '20px' }}>
          <div style={{ color: 'gray' }}>
              {formatMessage('code/note to seller:')}
          </div>
          <TextField
            value={noteToSeller}
            disabled={!isConsumer}
            InputProps={{ style: { color: !isConsumer ? 'red' : null } }}
            fullWidth
            id="noteToSeller"
            multiline
            rows={1}
            rowsMax={8}
            type={'text'}
            autoComplete="none"
            onBlur={({ target: { value } }) => {
                this.updateNoteToSeller(value);
            }}
            onKeyPress={({ keyCode, which, target: { value } }) =>
              (which === 13 || keyCode === 13) && this.updateNoteToSeller(value)
            }
            onChange={({ target: { value } }) => {
                this.setState({noteToSeller: value});
            }}
            style={{ margin: '7px 5px', fontSize: 18, flex: 1 }}
            />
        </div>}
        {!isConsumer && <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '20px' }}>
          <div style={{ color: 'gray' }}>
            {formatMessage('internal note:')}
          </div>
          <TextField
            value={internalNote ? internalNote : ""}
            InputProps={{ style: { color: 'red'} }}
            fullWidth
            id="textarea"
            multiline
            rows={1}
            rowsMax={8}
            type={'text'}
            autoComplete="none"
            onBlur={({ target: { value } }) => {
                this.updateNote(value);
            }}
            onKeyPress={({ keyCode, which, target: { value } }) =>
              (which === 13 || keyCode === 13) && this.updateNote(value)
            }
            onChange={({ target: { value } }) => {
                this.setState({internalNote: value});
            }}
            style={{ margin: '7px 5px', fontSize: 18, flex: 1 }}
          />
            {!isRestaurant && (customerRole === 'Buyer') && info.type === 'SO' && !info.captured && (
              <div style={{display:'flex', marginLeft:'20px'}}>
                <Button
                  className="no-line-height"
                  classes={{ root: classes.addBtn, label: classes.addBtnLabel }}
                  onClick={this.handleOpenModal}
                  variant="fab"
                  color="primary"
                >
                  <ContentAdd />
                </Button>
                <div className={classes.btnLabel}>
                  {formatMessage('Add Item')}
                </div>
                <AddItemToOrderModal
                  open={this.state.openModel}
                  orderId={info.id}
                  orderDeliveryDate={info.deliveryDate}
                  discount={info.discount}
                  handleClose={this.handleCloseModal}
                  handleAddItem={this.handleAddItemToOrder}
                  readOrder={readOrder}
                />
              </div>
            )}
        </div>}
        <div className="col-md-6 invoice-change-log">
          {Boolean(get(info, 'orderActivities.length')) && (
            <Fragment>
              <Button
                classes={{ root: classes.btnActivities }}
                onClick={() =>
                  this.setState({ showActivities: !showActivities })
                }
                id="activities"
              >
                <NotificationBadge
                  classes={{
                    badge: { badge: classes.badgeSpan },
                    root: { root: classes.badge },
                  }}
                >
                  {get(info, 'orderActivities.length')}
                </NotificationBadge>
                <span className="title">
                  {formatMessage('INVOICE CHANGE LOG')}
                </span>
              </Button>
              {showActivities && (
                <Activities
                  currentUser={currentUser}
                  order={info}
                  formatMessage={formatMessage}
                  onClick={onClickActivity}
                  currentActivity={currentActivity}
                  showAll={showAll}
                />
              )}
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

const wrappedTopPanel = withStyles(styles)(injectIntl(TopPanel));
wrappedTopPanel.displayName = 'TopPanel';

export default wrappedTopPanel;
